import React, {useEffect} from 'react';
import GraphicUtils from "../../../../../../utils/graphic-utils.js";
import ReportUtils from "../../../../../../utils/report-utils.js";

const BosConditions = ({data}) => {
  const reportId = "bos-conditions";
  const reportName = `Condições dos envolvidos`

  useEffect(() => {
    const values = data.map(i => i.qty);
    const labels = data.map(i => i.conditions);

    GraphicUtils.barChart(reportId, values, labels, false);
    data && data.length > 0 && ReportUtils.createExportableTable(labels, values, reportName);

  }, [data]);

  return (
    <>
      <div className="chart-report">
        <span className="chart-title">{`${reportName} ${data?.length >= 5 ? ' (TOP 5)' : ''}`}</span>
        <div className="mt-3" id={reportId}></div>
      </div>

      <div className="chart-divisor"></div>
    </>
  );
};

export default BosConditions;